import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, spacing, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../Select/Select.es.js';
import { SelectNative } from '../Select/SelectNative.es.js';
var CalendarWrapper = styled(Box).withConfig({
  componentId: "yxahmw-0"
})(["background-color:", ";color:", ";", " user-select:none;width:344px;"], themeMode({
  light: palette("neutral.0"),
  dark: palette("neutral.800")
}), themeMode({
  light: palette("neutral.800"),
  dark: palette("neutral.50")
}), function (_ref) {
  var isInitialized = _ref.isInitialized;
  return !isInitialized && "visibility: hidden";
});
var CalendarDatesContainer = styled(Box).withConfig({
  componentId: "yxahmw-1"
})(["display:grid;grid-template-columns:repeat(7,1fr);button:first-child{grid-column:", ";}"], function (_ref2) {
  var skipIndex = _ref2.skipIndex;
  return skipIndex;
});
var CalendarDateButton = styled("button").withConfig({
  componentId: "yxahmw-2"
})(["width:40px;height:40px;border-radius:50%;border:1px solid transparent;display:flex;justify-content:center;place-items:center;outline:none;cursor:pointer;margin:", " ", " 0 0;&:not(:disabled):hover{color:", ";background-color:", ";border-color:", ";}border-color:", ";&[disabled],&:disabled{color:", ";cursor:default;}", ""], spacing("xxs"), spacing("xxs"), palette("neutral.0"), palette("primary.500"), palette("primary.500"), function (_ref3) {
  var isToday = _ref3.isToday;
  return isToday && themeMode({
    light: palette("neutral.300"),
    dark: palette("neutral.500")
  });
}, themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), function (_ref4) {
  var active = _ref4.active;
  return active && css(["color:", ";background-color:", ";border-color:", ";"], palette("neutral.0"), palette("primary.500"), palette("primary.500"));
});
var CalendarHeader = styled(Box).withConfig({
  componentId: "yxahmw-3"
})(["border-bottom:", ";border-bottom-color:", ";padding:", ";display:flex;justify-content:space-between;align-items:center;margin-bottom:-1px;"], themeMode({
  light: "1px solid",
  dark: "1px solid"
}), themeMode({
  light: palette("neutral.200"),
  dark: palette("neutral.700")
}), spacing("lg"));
var CalendarWeeksContainer = styled(Box).withConfig({
  componentId: "yxahmw-4"
})(["display:grid;grid-template-columns:repeat(7,1fr);color:", ";"], themeMode({
  light: palette("neutral.500"),
  dark: palette("neutral.400")
}));
var CalendarHeaderSelect = styled(SelectNative).withConfig({
  componentId: "yxahmw-5"
})(["height:auto;min-height:auto;& > select{min-width:auto;padding:0 ", " 0 ", " !important;}"], spacing("xl"), spacing("xxs"));
var CalendarHeaderSelectCaret = styled("span").withConfig({
  componentId: "yxahmw-6"
})(["position:absolute;top:0;right:0;bottom:0;padding:0 ", ";display:flex;place-items:center;pointer-events:none;"], spacing("xxs"));
export { CalendarDateButton, CalendarDatesContainer, CalendarHeader, CalendarHeaderSelect, CalendarHeaderSelectCaret, CalendarWeeksContainer, CalendarWrapper };